import React from 'react';

export default function HomePage() {
  return (
    <div className="bg-slate-950 text-white min-h-screen">
      <main className="flex min-h-screen items-center justify-center px-6">
        <p className="text-center text-xl sm:text-2xl font-semibold">
          Home sendo reconstruída seção por seção.
        </p>
      </main>
    </div>
  );
}
